(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-width-video-modal"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-banner-with-video-modal-script')
    if (!window._banerWithVideoModal && $url) {
      window._banerWithVideoModal = $url.value
      var $script = document.createElement('script')
      $script.src = window._banerWithVideoModal
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-image-card"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-horizontal-image-card-script')
    if (!window._horizontalImageCard && $url) {
      window._horizontalImageCard = $url.value
      var $script = document.createElement('script')
      $script.src = window._horizontalImageCard
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-image-with-card"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-horizontal-image-with-text-card-script')
    if (!window._horizontalImageWithTextCard && $url) {
      window._horizontalImageWithTextCard = $url.value
      var $script = document.createElement('script')
      $script.src = window._horizontalImageWithTextCard
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-ariticle-script')
    if (!window._mainArticle && $url) {
      window._mainArticle = $url.value
      var $script = document.createElement('script')
      $script.src = window._mainArticle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-blog-script')
    if (!window._mainBlog && $url) {
      window._mainBlog = $url.value
      var $script = document.createElement('script')
      $script.src = window._mainBlog
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-banner-video"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-banner-with-video-modal-script')
    if (!window._banerWithVideoModal && $url) {
      window._banerWithVideoModal = $url.value
      var $script = document.createElement('script')
      $script.src = window._banerWithVideoModal
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-event"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-timeline-event-script')
    if (!window._timelineEvent && $url) {
      window._timelineEvent = $url.value
      var $script = document.createElement('script')
      $script.src = window._timelineEvent
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
